import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { Job } from 'elements-sdk'

// eslint-disable-next-line import/no-cycle
import { TasksService } from '../services/tasks.service'

@Component({
  templateUrl: './startJobModal.component.pug',
})
export class StartJobModalComponent {
  @Input() job: Job
  @Input() vars: Record<string, any> = {}

  constructor (
    private tasks: TasksService,
    private modalInstance: NgbActiveModal,
  ) { }

  async ngOnInit () {
    for (const v of this.job.variableDefinitions!) {
      const name = v.name as unknown as string
      if (v.default !== undefined && this.vars[name] === undefined) {
        this.vars[name] = v.default
      }
    }
  }

  start = async () => {
    await this.tasks.startJobRaw(this.job, this.vars)
    this.modalInstance.close()
  }

  cancel () {
    this.modalInstance.dismiss()
  }
}
